import { Button } from 'semantic-ui-react'
import Flexbox from 'flexbox-react'
import Layout from '../components/Layout'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'
import firebase from 'firebase'
import injectSheet from 'react-jss'

const styles = {
	getExercise: {
		height: '100%',
		width: '100%',
		'font-size': '40px !important'
	},
	bottomButton: {
		height: '20vh',
		width: '100%'
	}
}

function Home({ classes, user }) {
	return (
		<Layout.Container>
			<Layout.Grower>
				<Link to="/pick">
					<Button
						primary
						className={classes.getExercise}
						content="Get some exercise"
						icon="arrow right"
						labelPosition="right"
					/>
				</Link>
			</Layout.Grower>
			<Layout.Sticker>
				<Flexbox width="100%">
					<Flexbox flexGrow={1}>
						<Link
							className={classes.bottomButton}
							target="_blank"
							to="https://www.reddit.com/r/exerciseapp/"
						>
							<Button className={classes.bottomButton} secondary>Feedback</Button>
						</Link>
					</Flexbox>
					<Flexbox flexGrow={1}>
						<Button
							className={classes.bottomButton}
							onClick={() => firebase.auth().signOut()}
						>
							Sign Out - {user.displayName}
						</Button>
					</Flexbox>
				</Flexbox>
			</Layout.Sticker>
		</Layout.Container>
	)
}
Home.propTypes = {
	user: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired
}

export default injectSheet(styles)(Home)



// WEBPACK FOOTER //
// ./src/pages/Home.js